<!-- eslint-disable -->
<template lang="pug">
  div
    .form__title
      slot(name='title')
    form.form__body(action='javascript://' v-if='params')
      slot(name='multiplayer')
      template(v-if='!homework || !homework.editable || (homework && (homework.editable || usersIds))')
        .form__field(v-if="gameMode !== 'course'")
          label.form__label
            | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
          .form__field-body.form-container__select-examples
            cs-spin-input(
              :value="params.amountOfExamples",
              :max="amountOfExamples",
              :min="1",
              :disabled="params && (params.infinityAmountOfExamples || !!params.timeLimit)",
              @increase="increaseExamples",
              @decrease="decreaseExamples",
              @input="params.amountOfExamples = $event",
            )
            .form-container__select-infinity-mode(v-if="gameMode && gameMode === 'free-game'")
              cs-checkbox#infinityAmountOfExamples.form-container__checkbox(
                v-model="params.infinityAmountOfExamples"
                :checked="params && params.infinityAmountOfExamples"
                :disabled="params && (!!params.dictation || params.timeLimit)"
              )
              svg-icon.form-container__svg-icon(name="infinity" :aria-hidden="true" size="big")
        .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
          label.form__label
            | {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}
          .form__field-body
            cs-multiselect(
              :options="timeLimitValues",
              v-model="params.timeLimit"
              :placeholder="timeLimitLabel(params.timeLimit)"
              :multiple="false"
              :custom-label="timeLimitLabel"
            )
        .form__field.checkbox(v-if="gameMode === 'free-game'")
          label.form__label.checkbox__label
            |  {{  $i18n.t('trainer.trainer_gameFormSetting_dictation')  }}
          .form__field-body
            cs-checkbox(v-model="params.dictation", @change="dictationClicked")
        .form__field(v-if='params.dictation')
            label.form__label
              | {{ $i18n.t('trainer.trainer_gameFormSetting_timeToAnswer') }}
            .form__field-body
              cs-multiselect(
                v-model='selectedTimeForAnswer',
                :options="dictationSeconds",
                @select="timeForAnswerHandler",
                track-by="time",
                label="label",
                :multiple="false",
                :allow-empty="false",
                :show-labels="false",
                :searchable="false",
              )
        .form__field.checkbox(v-if='!homework')
          label.form__label.checkbox__label
            |  {{  $i18n.t('trainer.trainer_gameFormSetting_showAnswer')  }}
          .form__field-body
            cs-checkbox( v-model="params.showAnswer" )
        divider
        .row
          .col-md-3.col-xs-12
            .divisible-multiplier
              span.column-name
                |  {{  $i18n.t('trainer.trainer_gameFormSetting_multipliers')  }}
            .form__field_columns.form__field_numbers
              template(v-for='(number)  in  numbers')
                cs-checkbox.checkbox-for-numbers(
                  :checked="params.numbers && params.numbers.includes(number)",
                  @change="setNumber(number)"
                )
                  |   {{ number }}
      slot(name='parameters')
      slot(name='help')
      .buttons-container
        template(v-if='!usersIds')
          cs-button.form__button(type="button", pattern="primary-outline" color="blue" @click='cancel')
            | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
          template(v-if="gameMode && gameMode === 'free-game'")
            cs-button.form__button(:disabled="isMultiplierChosen" type="button", color="blue" @click='saveGameMode')
              | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
          template(v-else='')
            cs-button.form__button(:disabled="isMultiplierChosen" type="button", color="blue" @click='saveGame')
              | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
        template(v-else='')
          cs-button.form__button(type="button", pattern="primary-outline" color="blue" @click='cancel')
            | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
          cs-button.form__button(type="button", color="blue" @click='saveGame')
            | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    /*eslint-disable*/
    import { mapState } from 'vuex';
    import TrainerGames from '../../../config/trainer';
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import { getInitParameters } from '@/utils/trainer/getInitParameters';
    const DEFAULT_TIME_LIMIT = 0;
    import multiplayerFormMixin from '../../../utils/multiplayer/formMixin';
    import combiningCapacitiesMixin from '../utils/combiningCapacitiesMixin';

    import IntervalConfig from '../../trainer/configs/IntervalConfig';
    import Divider from '../../../elements/Divider.vue';
    import CsCheckbox from '../../../elements/CsCheckbox.vue';
    import CsButton from '@/elements/CsButton.vue';
    import CsMultiselect from '@/elements/CsMultiselect.vue';
    import SvgIcon from '@/elements/SvgIcon.vue';
    import CsSpinInput from '@/elements/CsSpinInput.vue';
    import { cloneDeep } from 'lodash';

    export default {
        components: { CsSpinInput, SvgIcon, CsMultiselect, CsButton, CsCheckbox, Divider },
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex',
        ],
        data() {
            return {
                numbers: [2, 3, 4, 5, 6, 7, 8, 9, 10],
                amountOfExamples: 100,
                timeLimitValues: IntervalConfig.timeLimitForFactorization,
                selectedTimeForAnswer: null,
                dictationSeconds: [...Array(101).keys()].slice(1).map(time => {
                    return {
                        time: time,
                        label: `${time} ` + this.$i18n.t('trainer.trainer_gameFormSettingValue_seconds'),
                    };
                }),
                params: null,
            };
        },
        mixins: [GameFormMixin, multiplayerFormMixin, combiningCapacitiesMixin],
        mounted() {
            if (this.isGeneratorSettings) {
                if (this.homework && this.homework.grades && this.homework.grades.length) {
                    let currentGameSettings = this.homework.grades[0].course.games.find(
                        element => element.slug === this.slug
                    );
                    this.gamesParameters[this.slug] = currentGameSettings.parameters.default;
                }
                if (this.homework && this.homework.courses) {
                    let copyCourses = this.homework.courses.filter(course =>
                        course.games.find(element => element.slug === this.slug)
                    );
                    copyCourses.sort((a, b) => a.level - b.level);
                    let currentGameSettings = copyCourses[0].games.find(element => element.slug === this.slug);
                    this.gamesParameters[this.slug] = currentGameSettings.parameters.default;
                }
            }

            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(
                        this,
                        'params',
                        getInitParameters({
                            slug: this.slug,
                            parameters: {
                                default: cloneDeep(this.gamesParameters[this.slug]),
                            },
                        })
                    );
                } else {
                    cloneDeep(TrainerGames.games).forEach(item => {
                        if (item.slug === this.slug) {
                            this.params = item.parameters.default;
                        }
                    });
                }
                this.params.infinityAmountOfExamples = true;
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }

            this.selectedTimeForAnswer = this.dictationSeconds[0];
        },
        watch: {
            'params.dictation'(val) {
                if (val) {
                    this.params.infinityAmountOfExamples = false;
                }
            },
            'params.amountOfExamples'(val) {
                if (val) {
                    this.params.timeLimit = DEFAULT_TIME_LIMIT;
                }
            },
            'params.timeLimit'(val) {
                if (val) {
                    this.params.infinityAmountOfExamples = true;
                } else {
                    if (!this.params.amountOfExamples) {
                        this.params.amountOfExamples = 1;
                    }
                    this.params.infinityAmountOfExamples = false;
                }
                if (val === null) {
                    this.params.timeLimit = 0;
                }
            },
            'params.amountOfActions'(val) {
                if (this.params.amountOfUnknowns >= +val) {
                    this.params.amountOfUnknowns = +val - 1;
                }
            },
            combiningDisabled(val) {
                if (val) {
                    this.params.combining = false;
                }
            },
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
            }),
            isGeneratorSettings() {
                return this.gameMode === 'generator-settings' && this.gamesParameters;
            },
            isMultiplierChosen() {
                return !this.params.numbers.length;
            },
        },
        methods: {
            timeForAnswerHandler(value) {
                this.params.timeForAnswer = value.time;
            },
            setNumber(number) {
                if (this.params.numbers.includes(number)) {
                    const index = this.params.numbers.findIndex(item => item === number);
                    this.params.numbers.splice(index, 1);
                    return;
                }

                this.params.numbers.push(number);
            },
            dictationClicked() {
                this.params.timeForAnswer = this.params.dictation ? 1 : '1';
            },
            selectMode(mode) {
                this.params.mode = mode.value;
            },
            combiningHandler(event) {
                let combining = event.target.checked;
                this.params.combining = combining;
                this.params.combiningDigitCapacities = [];
                if (combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            fractionsHandler(event) {
                let value = event.target.checked;
                this.params.fractions = value;
                if (value && this.params.combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            timeLimitLabel(amount) {
                return amount === 0
                    ? this.$i18n.t('trainer.trainer_gameFormSettingValue_off')
                    : amount + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_minutes');
            },
            decreaseExamples() {
                if (
                    this.params.amountOfExamples !== 1 &&
                    !this.params.timeLimit &&
                    !this.params.infinityAmountOfExamples
                ) {
                    this.params.amountOfExamples -= 1;
                }
            },
            increaseExamples() {
                if (
                    this.params.amountOfExamples !== this.amountOfExamples &&
                    !this.params.timeLimit &&
                    !this.params.infinityAmountOfExamples
                ) {
                    this.params.amountOfExamples += 1;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .divisible-multiplier {
        margin: 10px 5px;
    }

    .form__field_numbers {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 100%;
        @include media($xl) {
            width: 250px;
        }
        @include media($xlg) {
            width: 280px;
        }
    }

    .checkbox-for-numbers {
        margin-right: 15px;
        margin-bottom: $space-small !important;
    }

    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        max-width: 1020px;
        margin: 0 auto;
        box-sizing: border-box;
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }
    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: 0.5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }
    .form__field-body {
        flex-grow: 5;
    }

    .form-container__select {
        width: 100%;
        max-width: 220px;
        @media screen and (max-width: 767px) {
            max-width: none;
        }
        @include media($xl) {
            max-width: 280px;
        }
    }

    .form-container__select-examples {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        @media screen and (min-width: 700px) {
            flex-direction: row;
            align-items: center;
        }
    }

    .form-container__select-infinity-mode {
        display: flex;
        align-items: center;
        margin-top: 20px;
        @media screen and (min-width: 700px) {
            margin-top: 0;
        }
    }

    .form-container__checkbox {
        margin-left: 30px;
    }

    .form-container__svg-icon {
        opacity: 0.7;
        margin: 0 10px 10px 0;
    }

    .filter-capacities__field {
        width: 50%;
    }

    .filter-capacities__field-body {
        display: flex;
        flex-wrap: wrap;
        .cs-checkbox {
            margin-right: 20px;
        }
    }

    .buttons-container {
        display: flex;
        justify-content: center;
        margin: 20px;
        flex-direction: column;
        @include media($sm) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px;
        @include media($md) {
            margin: 0 10px;
        }
    }

    .checkbox {
        @media screen and (max-width: 767px) {
            flex-direction: row;
            align-items: center;
            flex-wrap: nowrap;
        }
    }

    .checkbox__label {
        @media screen and (max-width: 767px) {
            margin-bottom: 0;
            display: flex;
            align-items: center;
        }
    }
</style>
